<script>

  import { mapState } from 'vuex'
  import FetchArticles from '@/middleware/fetch-articles'
  import { HeadMeta } from '@/utils/head-meta'

  export default {
    middleware: [FetchArticles],
    scrollToTop: false,
    head () {
      return HeadMeta({
        metaTitle: this.metaTitle,
        metaDescription: this.config.fields.articlesArchiveDescription
      })
    },
    computed: {
      ...mapState({
        config: state => state.config,
        categories: state => state.blog.categories
      }),
      metaTitle () {
        const currentCategory = this.categories.find(category => category.fields.slug === this.$route.params.slug)
        if (currentCategory) return currentCategory.fields.title
        return ''
      }
    }
  }
</script>

<template>
  <div>
    <nuxt-child :key="$route.path" />
  </div>
</template>
